import React from 'react';

export const TextArea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = ({ className = '', ...props }) => (
  <textarea
    className={`w-full bg-dark-input/80 backdrop-blur-sm border border-dark-border/30 text-dark-text text-sm rounded-lg p-3 hover:border-dark-border/30 focus:ring-2 focus:ring-brand-400/50 focus:border-brand-500/60 focus:bg-dark-input outline-none resize-none min-h-[44px] transition-all duration-200 ease-out placeholder:text-dark-muted/60 ${className}`}
    {...props}
    data-testid='unknown-field-textarea'
    data-ux='field-edit'
    data-interaction-id='unknown-field-textarea' />
);
